import { render } from "./ActionHistoryEdit.vue?vue&type=template&id=f2a40ff4&scoped=true&ts=true"
import script from "./ActionHistoryEdit.vue?vue&type=script&lang=ts"
export * from "./ActionHistoryEdit.vue?vue&type=script&lang=ts"

import "./ActionHistoryEdit.vue?vue&type=style&index=0&id=f2a40ff4&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a40ff4"]])

export default __exports__